import React, { Component } from 'react'
import { Link, navigate } from 'gatsby'
import classNames from 'classnames'

class AccordeonComponent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            id: this.props.id,
            title: this.props.title,
            content: this.props.content,
            url: this.props.url,
            visible: false,
            timeoutID: null,
            mouseAction: null,
            endActionClick: false,
            endActionHover: false,
        }
    }

    toggleVisible = () => this.setState({ mouseAction: 'click', endActionClick: !this.state.visible, visible: !this.state.visible })

    hover = () => {
        if (!this.state.endActionHover) {
            const timeoutid = setTimeout(() => this.setState({ mouseAction: 'hover', endActionHover: true, visible: true }), 2000)
            this.setState({ timeoutID: timeoutid })
        }
    }

    out = () => {
        if (this.state.mouseAction === 'hover') {
            clearTimeout(this.state.timeoutID)
            this.setState({ endActionHover: false, mouseAction: null, visible: false })
        }
    }

    renderBtnName() {
        if (this.props.linkName) {
            return (
                <Link className="d-block" to={`${this.props.url}`}>
                    {' '}
                    {this.props.linkName}{' '}
                </Link>
            )
        }
        return (
            <Link className="d-block" to={`${this.props.url}`}>
                {' '}
                {`more details`}{' '}
            </Link>
        )
    }

    renderContent() {
        return (
            <div className="AccordeonComponent-content">
                <div className="a-content">{this.props.content}</div>
                <div className="more-details">{this.renderBtnName()}</div>
            </div>
        )
    }

    goToPage() {
        navigate(this.props.url)
    }

    render() {
        const windowGlobal = typeof window !== 'undefined' && window
        return (
            <div className="AccordeonComponent">
                <div
                    className={classNames('AccordeonComponent-title', {
                        active: this.state.visible,
                    })}
                >
                    <div className={`a-icon arrow-right`} onClick={() => this.goToPage()}>
                        <i className={'far fa-long-arrow-right'} />
                    </div>
                    <div className="a-title">
                        <Link onClick={windowGlobal.localStorage?.setItem('param', this.props.breadParams)} to={this.props.url} state={{ params: this.props.breadParams }}>
                            {this.props.title}
                        </Link>
                    </div>
                    <div className={`a-icon`} onClick={this.toggleVisible}>
                        <div className="btn-plus">
                            <i className={`far ${this.state.visible ? 'fa-minus' : 'fa-plus'}`} />
                        </div>
                    </div>
                </div>
                <div>{this.state.visible ? this.renderContent() : null}</div>
            </div>
        )
    }
}

export default AccordeonComponent
